/* eslint-disable */
// @ts-nocheck
/**
 * @fileoverview gRPC-Web generated client stub for worklayer.internal.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: internal/job_progression.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.worklayer = {};
proto.worklayer.internal = {};
proto.worklayer.internal.v1 = require('./job_progression_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.JobProgressionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetOpenItemsProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetOpenItemsProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetOpenItemsProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetOpenItemsProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetOpenItemsProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetOpenItemsProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setOpenItemsProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetOpenItemsProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetOpenItemsProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetOpenItemsProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setOpenItemsProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetOpenItemsProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetOpenItemsProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetJobStartedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetJobStartedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetJobStartedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetJobStartedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetJobStartedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetJobStartedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setJobStartedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetJobStartedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetJobStartedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetJobStartedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setJobStartedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetJobStartedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetJobStartedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetDraftInReviewProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetDraftInReviewProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setDraftInReviewProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetDraftInReviewProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetDraftInReviewProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetDraftInReviewProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setDraftInReviewProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetDraftInReviewProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetDraftInReviewProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetDraftApprovedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetDraftApprovedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setDraftApprovedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetDraftApprovedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetDraftApprovedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetDraftApprovedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setDraftApprovedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetDraftApprovedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetDraftApprovedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetDraftRejectedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetDraftRejectedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setDraftRejectedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetDraftRejectedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetDraftRejectedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetDraftRejectedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setDraftRejectedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetDraftRejectedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetDraftRejectedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetAuthorizationRequestedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetAuthorizationRequestedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setAuthorizationRequestedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetAuthorizationRequestedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetAuthorizationRequestedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetAuthorizationRequestedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setAuthorizationRequestedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetAuthorizationRequestedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetAuthorizationRequestedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetAuthorizationSignedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetAuthorizationSignedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setAuthorizationSignedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetAuthorizationSignedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetAuthorizationSignedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetAuthorizationSignedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setAuthorizationSignedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetAuthorizationSignedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetAuthorizationSignedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetReturnFiledProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetReturnFiledProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetReturnFiledProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetReturnFiledProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetReturnFiledProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetReturnFiledProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setReturnFiledProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetReturnFiledProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetReturnFiledProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetReturnFiledProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setReturnFiledProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetReturnFiledProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetReturnFiledProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetDeliverableCompletedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetDeliverableCompletedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setDeliverableCompletedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetDeliverableCompletedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetDeliverableCompletedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetDeliverableCompletedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setDeliverableCompletedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetDeliverableCompletedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetDeliverableCompletedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetPreparationCompletedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetPreparationCompletedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setPreparationCompletedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetPreparationCompletedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetPreparationCompletedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetPreparationCompletedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setPreparationCompletedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetPreparationCompletedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetPreparationCompletedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetReviewCompletedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetReviewCompletedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setReviewCompletedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetReviewCompletedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetReviewCompletedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetReviewCompletedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setReviewCompletedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetReviewCompletedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetReviewCompletedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetJobProgressionRequest,
 *   !proto.worklayer.internal.v1.GetJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_GetJobProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/GetJobProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetJobProgressionRequest,
  proto.worklayer.internal.v1.GetJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.GetJobProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.GetJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetJobProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.GetJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.GetJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.getJobProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/GetJobProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_GetJobProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetJobProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.GetJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.getJobProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/GetJobProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_GetJobProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetManyJobProgressionsRequest,
 *   !proto.worklayer.internal.v1.GetManyJobProgressionsResponse>}
 */
const methodDescriptor_JobProgressionService_GetManyJobProgressions = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/GetManyJobProgressions',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetManyJobProgressionsRequest,
  proto.worklayer.internal.v1.GetManyJobProgressionsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.GetManyJobProgressionsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.GetManyJobProgressionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.GetManyJobProgressionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.getManyJobProgressions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/GetManyJobProgressions',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_GetManyJobProgressions,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetManyJobProgressionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.GetManyJobProgressionsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.getManyJobProgressions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/GetManyJobProgressions',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_GetManyJobProgressions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.OverrideJobProgressionStepRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_OverrideJobProgressionStep = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/OverrideJobProgressionStep',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.OverrideJobProgressionStepRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.overrideJobProgressionStep =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/OverrideJobProgressionStep',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_OverrideJobProgressionStep,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.OverrideJobProgressionStepRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.overrideJobProgressionStep =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/OverrideJobProgressionStep',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_OverrideJobProgressionStep);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetExtensionInProgressProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetExtensionInProgressProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setExtensionInProgressProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetExtensionInProgressProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetExtensionInProgressProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetExtensionInProgressProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setExtensionInProgressProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetExtensionInProgressProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetExtensionInProgressProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetExtensionConfirmedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetExtensionConfirmedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setExtensionConfirmedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetExtensionConfirmedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetExtensionConfirmedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetExtensionConfirmedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setExtensionConfirmedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetExtensionConfirmedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetExtensionConfirmedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetExtensionAcceptedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetExtensionAcceptedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setExtensionAcceptedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetExtensionAcceptedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetExtensionAcceptedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetExtensionAcceptedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setExtensionAcceptedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetExtensionAcceptedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetExtensionAcceptedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetExtensionRejectedProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetExtensionRejectedProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setExtensionRejectedProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetExtensionRejectedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetExtensionRejectedProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetExtensionRejectedProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setExtensionRejectedProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetExtensionRejectedProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetExtensionRejectedProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetReadyToFileProgressionRequest,
 *   !proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 */
const methodDescriptor_JobProgressionService_SetReadyToFileProgression = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/SetReadyToFileProgression',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetReadyToFileProgressionRequest,
  proto.worklayer.internal.v1.UpdateJobProgressionResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UpdateJobProgressionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UpdateJobProgressionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.setReadyToFileProgression =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetReadyToFileProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetReadyToFileProgression,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetReadyToFileProgressionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UpdateJobProgressionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.setReadyToFileProgression =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/SetReadyToFileProgression',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_SetReadyToFileProgression);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest,
 *   !proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse>}
 */
const methodDescriptor_JobProgressionService_GetAdditionalProgressionFlowsAvailableForJob = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.JobProgressionService/GetAdditionalProgressionFlowsAvailableForJob',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest,
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse,
  /**
   * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.JobProgressionServiceClient.prototype.getAdditionalProgressionFlowsAvailableForJob =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/GetAdditionalProgressionFlowsAvailableForJob',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_GetAdditionalProgressionFlowsAvailableForJob,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.GetAdditionalProgressionFlowsAvailableForJobResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.JobProgressionServicePromiseClient.prototype.getAdditionalProgressionFlowsAvailableForJob =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.JobProgressionService/GetAdditionalProgressionFlowsAvailableForJob',
      request,
      metadata || {},
      methodDescriptor_JobProgressionService_GetAdditionalProgressionFlowsAvailableForJob);
};


module.exports = proto.worklayer.internal.v1;

